<template>
  <div class="eyebrow">
    <div class="eyebrow__label">
      Share Feedback
    </div>
    <h1
      class="eyebrow__title"
      tabindex="-1"
    >
      {{ title }}
    </h1>
    <div
      v-if="subtitle"
      class="eyebrow__subtitle"
    >
      {{ subtitle }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  mounted () {
    // Location and provider hide this header until they know the step will
    // stay. Focusing here covers that late render as well as a normal step.
    this.$nextTick(() => {
      const heading = this.$el.querySelector('.eyebrow__title')
      if (heading) heading.focus()
    })
  }
}
</script>

<style lang="scss" scoped>
.eyebrow {
  background: #fff;
  padding: 15px 20px;

  &__label {
    color: $text-muted;
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
    text-transform: uppercase;
  }

  &__title {
    color: $text-primary;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.2;
    margin-top: 2px;

    // Focus moves here when the step is shown so screen readers announce it.
    // It is not tabbable, so a focus ring here would only ever show up
    // unprompted on navigation.
    &:focus {
      outline: none;
    }
  }

  &__subtitle {
    color: #656e8b;
    font-size: 14px;
    line-height: 1.1;
    margin-top: 2px;
  }
}
</style>
